import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, of } from 'rxjs';

import * as fromItsmActions from './itsm.actions';
import { ItsmEntitiesMiscDomainService } from '@apps/its2/domain/entities-misc-domain.service';
import { DepartmentsMiscDomainService } from '@apps/its2/domain/departments-misc-domain.service';

@Injectable()
export class BackItsmEffects
{
    constructor (
        private actions: Actions,
        private entitiesService: ItsmEntitiesMiscDomainService,
        private departmentsService: DepartmentsMiscDomainService
    )
    { }

    backItsmSubEntitiesRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromItsmActions.BackItsmSubEntitiesRequested),
                    switchMap(({ entityId }) =>
                        this.entitiesService.getSubEntities(entityId)
                            .pipe(
                                map((subEntities: string[]) =>
                                    fromItsmActions.BackItsmSubEntitiesSucceded({ subEntities })
                                ),
                                catchError(() =>
                                    of(fromItsmActions.BackItsmSubEntitiesFailed())
                                )
                            )
                    )
                )
    );

    backItsmSaveSubEntitiesRequested = createEffect(
        () =>
            this.actions
                .pipe(
                    ofType(fromItsmActions.BackItsmSaveSubEntitiesRequested),
                    switchMap(({ entityId, subEntities }) =>
                        this.entitiesService.saveSubEntities(entityId, subEntities)
                            .pipe(
                                map(() =>
                                    fromItsmActions.BackItsmSaveSubEntitiesSucceded({ subEntities })
                                ),
                                catchError(() =>
                                    of(fromItsmActions.BackItsmSaveSubEntitiesFailed())
                                )
                            )
                    )
                )
    );

    backItsmDepartmentRequested = createEffect (
        () =>
            this.actions
                .pipe(
                    ofType(fromItsmActions.BackItsmRessourcesRequested),
                    switchMap(({ departmentCode }) =>
                        this.departmentsService.getRessources(departmentCode)
                            .pipe(
                                map((ressources) =>
                                    fromItsmActions.BackItsmRessourcesSucceeded({ ressources })
                                ),
                                catchError(() =>
                                    of(fromItsmActions.BackItsmRessourcesFailed())
                                )
                            )
                    )
                )
    );
}
